module.exports = __webpack_public_path__ + "static/art2-3b363ac6c7d6c2e18be9902d9b80dc8b.png";